import { render } from "./RequestProducts.vue?vue&type=template&id=6bcb2fbb&scoped=true"
import script from "./RequestProducts.vue?vue&type=script&lang=js"
export * from "./RequestProducts.vue?vue&type=script&lang=js"

import "./RequestProducts.vue?vue&type=style&index=0&id=6bcb2fbb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcb2fbb"]])

export default __exports__